import { z } from 'zod';
export const MEMBER_ROLES = ['owner', 'parent', 'member', 'child'];
export const memberRoleSchema = z.enum(MEMBER_ROLES);
/** Roles that can be given when adding or editing someone (there is exactly one owner). */
export const ASSIGNABLE_ROLES = ['parent', 'member', 'child'];
export const assignableRoleSchema = z.enum(ASSIGNABLE_ROLES);
export const MEMBER_STATUSES = ['active', 'deactivated'];
export const memberStatusSchema = z.enum(MEMBER_STATUSES);
//# sourceMappingURL=roles.js.map